import React from 'react';
import { Field, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import Button from 'components/buttons/Button';
import RenderFormInput from 'components/forms/RenderFormInput';
import { requiredValidator, handleBlur, emailValidator } from 'utils/validators';

const TestEmailForm = ({
  handleSubmit,
  submitting,
  toggle,
  pristine,
}) => (
  <form className="instance-form mt-2" onSubmit={handleSubmit}>
    <div className="instance-form__body">
      {/* eslint-disable jsx-a11y/label-has-for */}
      <label className="mt-2">Email to send to</label>
      <Field
        maxLength="255"
        name="email"
        label="Ex: bob@prvolt.com"
        component={RenderFormInput}
        type="text"
        onBlur={handleBlur}
        validate={[requiredValidator, emailValidator]}
      />
    </div>
    <div className="instance-form__footer">
      <Button
        type="button"
        color="secondary"
        variant="text"
        onClick={toggle}
      >
        Cancel
      </Button>
      <Button
        className="mr-1"
        disabled={pristine || submitting}
        color="primary"
        variant="contained"
        type="submit"
      >
        Send
      </Button>
    </div>
  </form>
);

TestEmailForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  toggle: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
  pristine: PropTypes.bool,
};

TestEmailForm.defaultProps = {
  submitting: false,
  pristine: true,
};

export default reduxForm({
  form: 'testEmailForm',
})(TestEmailForm);
